module.exports = __webpack_public_path__ + "static/media/smartobject_scratch.24974dcc.png";